import React from "react";
import { hydrate } from "react-dom";

import GlobalHeaderContainer from "shared/containers/GlobalHeaderContainer";

const element = document.getElementById("globalHeader");
const initialProps = window.GLOBAL_UI_INITIAL_PROPS;

hydrate(<GlobalHeaderContainer {...initialProps} />, element);

if (process.env.NODE_ENV === "development") {
  if (module.hot) {
    module.hot.accept();
  }
}
